import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseFormModalComponent } from 'components/modal/base-form-modal.component';
import { TooltipComponent } from '../../../../components/tooltip/tooltip.component';
import { ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MAX_LENGTH_INFO_FOR_CLIENT } from 'util/form.utility';
import { TranslateModule } from '@ngx-translate/core';
import { BackofficeReadingRoomSubmissionCard } from 'types/service.interface';
import { formatDate, formatTime } from 'util/date.utility';
@Component({
  selector: 'app-approve-submission-modal',
  standalone: true,
  imports: [TooltipComponent, ReactiveFormsModule, NgClass, TranslateModule],
  templateUrl: './approve-submission-modal.component.html',
  styleUrl: './approve-submission-modal.component.scss'
})
export class ApproveSubmissionModalComponent extends BaseFormModalComponent implements OnInit {
  @ViewChild('content') content: any;
  shouldRenderTooltip: boolean = false;
  maxDescriptionLength: number = MAX_LENGTH_INFO_FOR_CLIENT;
  isConfirmModalOpen: boolean = false;
  @Input() application?: BackofficeReadingRoomSubmissionCard;
  public readonly formatDate = formatDate;
  public readonly formatTime = formatTime;

  get informationForClient(): AbstractControl<any, any> | null {
    return this.form.get('informationForClient');
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      informationForClient: ['']
    });
  }

  show() {
    this.open(this.content);
    setTimeout(() => {
      this.shouldRenderTooltip = true;
    }, 10);
  }

  hide() {
    this.close();
    this.shouldRenderTooltip = false;
  }

  onConfirm() {
    this.submitAttempted = true;
    if (this.form.valid) {
      this.confirm.emit(this.informationForClient?.value ?? null);
      this.modalService.dismissAll();
    } else {
      this.toastService.showFormValidationError();
    }
    this.form.reset();
  }
}
